module.exports = __webpack_public_path__ + "img/light-tree.131e20a5.svg";